import TableWrapper from './TableWrapper';
import LastTableCell from './LastTableCell';

export default TableWrapper;

export { LastTableCell };
